export default __webpack_public_path__ + "static/media/Payroll_Filled_Active.88ca64ac.svg";